import React from "react";
import "./PolicyCard.css";
import { Markup } from "interweave";

const AboutCard = ({ title, description }) => {
  return (
    <>
    
      <div className="left-col-box mt-3 rounded pb-3">
        <h5 className="text-center text-warning py-4 ">{title}</h5>
        <div className="bg-about mx-3 p-2 text-light  rounded">
          <Markup content={description}></Markup>
        </div>
      </div>
    </>
  );
};

export default AboutCard;
